import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'sanitize',
    standalone: false
})
export class SanitizePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(v?: string): string {
    if (! v) return ''
    let safe = this._sanitizer.sanitize(1, v)
    if (safe) return safe
    else return ''
  }
}
